import React, { useEffect, useState } from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useAuthQueryParams from './hooks/useAuthQueryParams';
import LoadingPage from './LoadingPage';
import { fetchUserForEvent } from '../actions/user';
import {
  getEventRedirectDestination,
  requiresAuthCheck
} from '../utils/getEventRedirectDestination';

const EventDefaultRedirect = () => {
  const { eventId, eventType } = useParams();
  const { search = '' } = useLocation();
  const dispatch = useDispatch();

  const { registrationType } = useSelector((state) => state.event.event);
  const { user } = useSelector((state) => state.user);
  const {
    regMethod,
    preview,
    audienceToken,
    jwtToken
  } = useAuthQueryParams();

  const [authChecked, setAuthChecked] = useState(false);

  const needsAuthCheck = requiresAuthCheck({
    registrationType,
    preview,
    jwtToken,
    audienceToken,
    regMethod
  });

  useEffect(() => {
    if (!registrationType || !eventId) return;

    if (!needsAuthCheck) {
      setAuthChecked(true);
      return;
    }

    if (user === null) {
      const checkAuth = async () => {
        try {
          await dispatch(fetchUserForEvent(eventId));
        } catch (e) {
          console.debug('User not authenticated, will redirect to registration');
        } finally {
          setAuthChecked(true);
        }
      };
      checkAuth();
    } else {
      setAuthChecked(true);
    }
  }, [registrationType, eventId, user, needsAuthCheck, dispatch]);

  if (!registrationType || (needsAuthCheck && !authChecked)) {
    return <LoadingPage />;
  }

  const base = `/event/${eventId}${eventType ? `/${eventType}` : ''}`;

  const destination = getEventRedirectDestination({
    registrationType,
    user,
    preview,
    jwtToken,
    audienceToken,
    regMethod
  });

  return <Redirect to={`${base}/${destination}${search}`} />;
};

export default EventDefaultRedirect;
